export enum Spacing {
  xxsm = 2,
  xsm = 4,
  sm = 8,
  md = 16,
  lg = 32,
  xlg = 64
}

export enum BorderRadius {
  sm = 5,
  md = 10,
  lg = 15
}

export const SCREEN_RATIO = 0.46
export const MIN_HEIGHT = 524
export const MIN_WIDTH = MIN_HEIGHT * SCREEN_RATIO
